import { AppRoute } from 'src/types/Route';
import aiManageRoutes from './modules/ai-manage';
import baseRoutes from './modules/base';
import dataPermissionRoutes from './modules/data-permission';
import dataSourceRoutes from './modules/data-source';
// import logRoutes from './modules/log';
import UserPermissionRoutes from './modules/user-permission';

const routes: AppRoute[] = [
  ...aiManageRoutes,
  ...baseRoutes,
  ...dataSourceRoutes,
  // ...logRoutes,
  ...UserPermissionRoutes,
  ...dataPermissionRoutes,
];

export default routes;
